import { Outlet } from 'react-router';

import { GUEST_CARD_WIDTH_PX } from './layout.constant';
import { useScreenInfo } from './screen-handle';

/**
 * T3 `Guest / Center`(Figma 2146:30057). 헤더 없음(DD-14 Q7), 화면 가운데에 카드 하나.
 * `card`: login 900 · narrow 600 · none(내용 크기 그대로 — 앱 시작 · 연결 실패). 라우트의 `handle.screen.card`.
 * 카드의 면 · 모서리는 내용(LoginCard 등)이 가진다 — 이 틀은 폭과 가운데 맞춤만.
 */
export function GuestCenterLayout() {
  const card = useScreenInfo()?.card ?? 'narrow';
  return (
    <main
      data-template="guest-center"
      data-card={card}
      className="flex min-h-screen items-center justify-center bg-bg-canvas px-6 text-fg-default"
    >
      <div style={{ width: GUEST_CARD_WIDTH_PX[card] }} className="flex flex-col">
        <Outlet />
      </div>
    </main>
  );
}
